var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Teilen"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teilen",
    clipPath: "url(#clip-Teilen)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1413",
    transform: "translate(-16886 -4691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_528",
    d: "M139.415,27.274a1,1,0,0,1-1-1v-14.9l-3.43,2.875A1,1,0,0,1,133.7,12.72l5.072-4.253a1,1,0,0,1,1.643.767v17.04a1,1,0,0,1-1,1",
    transform: "translate(16769 4691)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_529",
    d: "M144.5,14.486a1,1,0,0,1-.641-.233L138.774,10a1,1,0,1,1,1.283-1.534l5.088,4.252a1,1,0,0,1-.643,1.767",
    transform: "translate(16769 4691)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_530",
    d: "M132.978,32.745a3.585,3.585,0,0,1-3.553-3.47V20.244a3.607,3.607,0,0,1,3.694-3.5h1.034a1,1,0,0,1,0,2h-1.065a1.571,1.571,0,0,0-1.663,1.532v8.967a1.547,1.547,0,0,0,1.633,1.5h12.862a1.594,1.594,0,0,0,1.612-1.533V20.244a1.577,1.577,0,0,0-1.632-1.5h-1.1a1,1,0,0,1,0-2h1.064a3.587,3.587,0,0,1,3.662,3.467v9.032a3.594,3.594,0,0,1-3.694,3.5H133.087l-.109,0",
    transform: "translate(16769 4691)",
    fill: "inherit"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.99eab877.svg";
export { ForwardRef as ReactComponent };